export const rawGraphData = {
  datasets: [
    {
      name: 'ICX Price',
      type: 'area',
      data: [
        0.0203,
        0.0209,
        0.0251,
        0.2656,
        0.0263,
        0.0273,
        0.0267,
        0.0265,
        0.0278,
        0.0246,
        0.0249,
        0.0246,
        0.0255,
        0.0287,
        0.0285,
        0.0287,
        0.0462,
        0.0282,
        0.0271,
        0.026,
        0.025,
        0.0237,
        0.0232,
        0.0239,
        0.0225,
        0.0219,
        0.0224,
        0.0245,
        0.0216,
        0.0228,
        0.0238,
        0.0212,
        0.0243,
        0.0217,
        0.0185,
        0.0177,
        0.0176,
        0.0179,
        0.0162,
        0.0156,
        0.0156,
        0.0157,
        0.0158,
        0.0152,
        0.0153,
        0.0151,
        0.0147,
        0.0146,
        0.0146,
        0.015,
        0.0153,
        0.0156,
        0.0152,
        0.0151,
        0.0152,
        0.0157,
        0.0242,
        0.0141,
        0.014,
        0.0142,
        0.0136,
        0.014,
        0.0136,
        0.0138,
        0.0138,
        0.014,
        0.0139,
        0.0139,
        0.0145,
        0.0145,
        0.0141,
        0.0295,
        0.0134,
        0.0136,
        0.0122,
        0.0121,
        0.0117,
        0.0123,
        0.0121,
        0.013,
        0.0124,
        0.0131,
        0.013,
        0.0135,
        0.0145,
        0.0158,
        0.0145,
        0.0155,
        0.0126,
        0.0124,
        0.0122,
        0.0118,
        0.012,
        0.0121,
        0.0116,
        0.0112,
        0.0147,
        0.0116,
        0.0114,
        0.011,
        0.0104,
        0.0111,
        0.0115,
        0.0152,
        0.0117,
        0.0122,
        0.0122,
        0.0114,
        0.0114,
        0.0119,
        0.0127,
        0.013,
        0.0139,
        0.0158,
        0.0164,
        0.0166,
        0.0165,
        0.0157,
        0.0153,
      ],
    },
    {
      name: 'ICX Volume',
      type: 'column',
      data: [
        13972,
        33978,
        30329,
        37435,
        40302,
        45434,
        60955,
        86919,
        44094,
        9056,
        10916,
        10880,
        21788,
        100903,
        43332,
        15438,
        72169,
        16616,
        171041,
        42106,
        126812,
        14146,
        29963,
        35768,
        11708,
        25300,
        14301,
        74410,
        42978,
        23751,
        36792,
        43823,
        123279,
        109474,
        14852,
        23089,
        19624,
        45441,
        37735,
        19616,
        24139,
        45264,
        12515,
        11557,
        8260,
        21302,
        18980,
        6399,
        28368,
        27999,
        20266,
        21148,
        34566,
        10261,
        31914,
        9761,
        12277,
        4856,
        9925,
        15647,
        18037,
        15870,
        4252,
        10424,
        25330,
        6538,
        12502,
        14614,
        20673,
        33373,
        16181,
        11062,
        10743,
        25857,
        7073,
        17707,
        4764,
        13629,
        9468,
        11124,
        16359,
        12846,
        41811,
        22664,
        23096,
        30976,
        12117,
        6265,
        12202,
        6902,
        11115,
        4583,
        7137,
        5072,
        8152,
        13316,
        4763,
        5471,
        11822,
        6372,
        3455,
        10005,
        9796,
        5419,
        8353,
        7515,
        13496,
        9384,
        20482,
        20306,
        14637,
        5681,
        8928,
        8766,
        10664,
        22888,
        16057,
        17678,
        2461,
      ],
    },
  ],
  options: {
    chart: {
      toolbar: {
        show: false,
      },
      height: 350,
      type: 'line',
      stacked: false,
    },
    stroke: {
      width: [0, 2, 5],
      curve: 'smooth',
      colors: ['#d3d3d3'],
    },
    plotOptions: {
      bar: {
        columnWidth: '50%',
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
    fill: {
      opacity: 1,
      colors: ['#F1F8FC'],
      type: 'solid',
    },
    markers: {
      size: 0,
    },
    xaxis: {
      type: 'datetime',
    },
    yaxis: [
      {
        title: {
          text: 'ICX Price',
        },
      },
      {
        opposite: true,
        title: {
          text: 'ICX Volume',
        },
        decimalsInFloat: 0,
      },
    ],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== 'undefined') {
            return y.toFixed(5);
          }
          return y;
        },
      },
    },
    labels: [
      '2020-08-17',
      '2020-08-16',
      '2020-08-15',
      '2020-08-14',
      '2020-08-13',
      '2020-08-12',
      '2020-08-11',
      '2020-08-10',
      '2020-08-09',
      '2020-08-08',
      '2020-08-07',
      '2020-08-06',
      '2020-08-05',
      '2020-08-04',
      '2020-08-03',
      '2020-08-02',
      '2020-08-01',
      '2020-07-31',
      '2020-07-30',
      '2020-07-29',
      '2020-07-28',
      '2020-07-27',
      '2020-07-26',
      '2020-07-25',
      '2020-07-24',
      '2020-07-23',
      '2020-07-22',
      '2020-07-21',
      '2020-07-20',
      '2020-07-19',
      '2020-07-18',
      '2020-07-17',
      '2020-07-16',
      '2020-07-15',
      '2020-07-14',
      '2020-07-13',
      '2020-07-12',
      '2020-07-11',
      '2020-07-10',
      '2020-07-09',
      '2020-07-08',
      '2020-07-07',
      '2020-07-06',
      '2020-07-05',
      '2020-07-04',
      '2020-07-03',
      '2020-07-02',
      '2020-07-01',
      '2020-06-30',
      '2020-06-29',
      '2020-06-28',
      '2020-06-27',
      '2020-06-26',
      '2020-06-25',
      '2020-06-24',
      '2020-06-23',
      '2020-06-22',
      '2020-06-21',
      '2020-06-20',
      '2020-06-19',
      '2020-06-18',
      '2020-06-17',
      '2020-06-16',
      '2020-06-15',
      '2020-06-14',
      '2020-06-13',
      '2020-06-12',
      '2020-06-11',
      '2020-06-10',
      '2020-06-09',
      '2020-06-08',
      '2020-06-07',
      '2020-06-06',
      '2020-06-05',
      '2020-06-04',
      '2020-06-03',
      '2020-06-02',
      '2020-06-01',
      '2020-05-31',
      '2020-05-30',
      '2020-05-29',
      '2020-05-28',
      '2020-05-27',
      '2020-05-26',
      '2020-05-25',
      '2020-05-24',
      '2020-05-23',
      '2020-05-22',
      '2020-05-21',
      '2020-05-20',
      '2020-05-19',
      '2020-05-18',
      '2020-05-17',
      '2020-05-16',
      '2020-05-15',
      '2020-05-14',
      '2020-05-13',
      '2020-05-12',
      '2020-05-11',
      '2020-05-10',
      '2020-05-09',
      '2020-05-08',
      '2020-05-07',
      '2020-05-06',
      '2020-05-05',
      '2020-05-04',
      '2020-05-03',
      '2020-05-02',
      '2020-05-01',
      '2020-04-30',
      '2020-04-29',
      '2020-04-28',
      '2020-04-27',
      '2020-04-26',
      '2020-04-25',
      '2020-04-24',
      '2020-04-23',
      '2020-04-22',
      '2020-04-21',
    ],
  },
};
